import { EmployeePlaceholder } from '@/model/planning/EmployeePlaceholder'
import _ from 'lodash'
import { EmployeeAvailableForPlanning } from '@/model/planning/EmployeeAvailableForPlanning'
import { PlannedEmployee } from "@/model/planning/PlannedEmployee";
import { PlanningGroup } from '@/model/companyStructure/PlanningGroup'

export class AutomaticallyPlannedEmployee {
  private constructor (
    readonly number: number,
    readonly employeeId: number | undefined,
    readonly fullName: string,
    readonly kapacity: string | undefined,
    readonly competence: string,
    readonly education: string,
    readonly taskId: number | undefined,
    readonly taskName: string | undefined,
    readonly isFloater: boolean,
    readonly note: string | undefined,
    readonly startDate: Date,
    readonly endDate: Date,
    readonly planningGroupName: string | undefined,
    readonly projectId?: number | undefined,
    readonly detailID?: number | undefined,
  ) {}

  public get isPlaceholder (): boolean {
    return !!this.employeeId
  }

  public static createListFromResponse (data: any, planningGroupList: PlanningGroup[]): Array<AutomaticallyPlannedEmployee | EmployeePlaceholder> {
    return data.map((item: any): AutomaticallyPlannedEmployee | EmployeePlaceholder => {

      if (item.MitarbeiterID) {
        //const startDate = moment().hours(item.hourStart).minutes(item.minStart)
        //const tempStart = moment().hours(item.hourStart).minutes(item.minStart)
        //const endDate = tempStart.add(item.hourDauer, 'h').add(item.minDauer, 'm')
        const planningGroup: PlanningGroup | undefined = planningGroupList.find((i: PlanningGroup) => item.Planungsgruppe === i.planningGroup)

        return new AutomaticallyPlannedEmployee(
          item.Zeile,
          item.MitarbeiterID || undefined,
          item.Name,
          item.Kapazitat && item.Kapazitat.trim().length && item.Kapazitat || undefined,
          item.Kompetenz || '',
          item.Bildung || '',
          item.ArbeitID || undefined,
          item.Arbeit && item.Arbeit.trim().length && item.Arbeit || undefined,
          item.springer,
          item.NotizElement && item.NotizElement.trim().length && item.NotizElement || undefined,
          item.startDate,
          item.endDate,
          planningGroup ? planningGroup.planningGroupName : undefined,
          item.ProjectSerie ? item.ProjectSerie : undefined,
          item.detailID ? item.detailID : undefined
        )
      } else {
        return EmployeePlaceholder.createFromEmployeePlanningResponseItem(item, planningGroupList)
      }
    })
  }

  public static createFromEmployeeAvailableForPlanningAndPlaceholder (
    employee: EmployeeAvailableForPlanning | PlannedEmployee,
    placeholder: EmployeePlaceholder,
    plannedEmployee?: PlannedEmployee): AutomaticallyPlannedEmployee {
    return new AutomaticallyPlannedEmployee(
      placeholder.number,
      employee.id,
      employee.name,
      employee.capacity,
      plannedEmployee ? plannedEmployee.competenceName ? plannedEmployee.competenceName : '' : '', //placeholder.competence : placeholder.competence,
      plannedEmployee ? plannedEmployee.educationName ? plannedEmployee.educationName : '' : '', //placeholder.education : placeholder.education,
      plannedEmployee ? plannedEmployee.taskId : placeholder.taskId,
      plannedEmployee ? plannedEmployee.taskName : placeholder.taskName,
      employee.isFloater,
      plannedEmployee ? plannedEmployee.note : placeholder.note,
      plannedEmployee ? _.cloneDeep(plannedEmployee.start) : _.cloneDeep(placeholder.startDate),
      plannedEmployee ? _.cloneDeep(plannedEmployee.end) : _.cloneDeep(placeholder.startDate),
      employee.planingGroupName ? employee.planingGroupName : undefined
    )
  }

  public static createFromAutoPlannedEmployeeListAndPlannedEmployeeList (
    autoEmployeeList: AutomaticallyPlannedEmployee[],
    plannedEmployeeList: PlannedEmployee[]
  ): AutomaticallyPlannedEmployee[] {
    return autoEmployeeList.map((item: AutomaticallyPlannedEmployee) => {
      const plannedEmployee: PlannedEmployee | undefined = _.find(plannedEmployeeList, {number: item.number})

      return new AutomaticallyPlannedEmployee(
        item.number,
        item.employeeId,
        item.fullName,
        item.kapacity,
        item.competence,
        item.education,
        plannedEmployee ? plannedEmployee.taskId : item.taskId,
        plannedEmployee ? plannedEmployee.taskName : item.taskName,
        item.isFloater,
        plannedEmployee ? plannedEmployee.note : item.note,
        plannedEmployee ? _.cloneDeep(plannedEmployee.start) : _.cloneDeep(item.startDate),
        plannedEmployee ? _.cloneDeep(plannedEmployee.end) : _.cloneDeep(item.endDate),
        item.planningGroupName ? item.planningGroupName : undefined
      )
    })
  }
}
